<template>
  <fieldset class="step step-5">
    <Section :title="stepTitle">
    <CertificationFormGroup name="q_5_1">
      <TrueFalseControl
        id="q_5_1"
        v-model="form.q_5_1"
        number="1"
        label="Organizator dopuszcza udział osób towarzyszących"
        help="Małżonkowie, partnerzy, rodzina lub inne osoby towarzyszące HCP, które nie są obiektywnie zawodowo zainteresowane informacjami przekazywanymi podczas wydarzenia."
        :disabled="formDisabled"
      />
    </CertificationFormGroup>
    <transition name="slide-fade">
      <div v-show="form.q_5_1">
        <CertificationFormGroup name="q_5_1a">
          <TrueFalseControl
            id="q_5_1a"
            v-model="form.q_5_1a"
            number="1a"
            label="Organizator niniejszym oświadcza, że udział osób towarzyszących nie zostanie sfinansowany ze środków pochodzących od firm członkowskich Izby POLMED lub MedTech Polska"
            :disabled="formDisabled"
          />
        </CertificationFormGroup>
        
          <CertificationFormGroup name="q_5_1b">
            <TrueFalseControl
              id="q_5_1b"
              v-model="form.q_5_1b"
              number="1b"
              label="Organizator przewiduje oddzielną opłatę rejestracyjną za udział osób towarzyszących"
              :disabled="formDisabled"
            />
          </CertificationFormGroup>
        
          <CertificationFormGroup name="q_5_1c">
            <TrueFalseControl
              id="q_5_1c"
              v-model="form.q_5_1c"
              number="1c"
              label="Organizator zezwala na udział osób towarzyszących w merytorycznej części wydarzenia"
              label-description="np. udział w obradach, wystawie firm, przerwach kawowych, obiadach"
              :disabled="formDisabled"
            />
          </CertificationFormGroup>
         
      </div>
    </transition>
    </Section>
  </fieldset>
</template>

<script>
import BaseCertificationFormStep from '@/components/Base/Certification/BaseCertificationFormStep'
import TrueFalseControl from '@/components/Controls/TrueFalseControl'

export default {
  name: 'CertificationFormStep5',
  components: {
    TrueFalseControl
  },
  extends: BaseCertificationFormStep
}
</script>
</transition>
</CertificationFormGroup>

</transition>